import React, { useState, useEffect } from 'react';
import './GeneratingModal.css';

function GeneratingModal({ isOpen, selectedOpinionTitle, stage = 'generating' }) {
  const [currentStage, setCurrentStage] = useState(stage);
  
  useEffect(() => {
    setCurrentStage(stage);
  }, [stage]);
  
  // Change stage after 3 seconds
  useEffect(() => {
    if (isOpen && currentStage === 'generating') {
      const timer = setTimeout(() => {
        setCurrentStage('humanizing');
      }, 3000); // Change to humanizing after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [isOpen, currentStage]);
  
  if (!isOpen) return null;

  const getStageText = () => {
    if (currentStage === 'humanizing') {
      return 'Following 3 step humanization process';
    }
    return 'Generating task';
  };

  return (
    <div className="generating-modal-overlay">
      <div className="generating-modal-content">
        <div className="generating-animation">
          <div className="spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
        </div>
        <h2 className="generating-title">{getStageText()}</h2>
        <p className="generating-subtitle">
          {selectedOpinionTitle ? `Processing: ${selectedOpinionTitle}` : 'Please wait while we create your personalized task...'}
        </p>
        <div className="generating-progress">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </div>
        <p className="generating-note">
          {currentStage === 'humanizing' 
            ? 'This may take 2-5 minutes for best results'
            : 'This may take 30-60 seconds'}
        </p>
      </div>
    </div>
  );
}

export default GeneratingModal;

